import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/header2';
import Footer from '../layout/footer4';
import Testimonial1 from './../element/testimonial1';
import BlogSlider1 from '../element/blogSlider1';
import {
  getAllAbout,
  getAllDirectors,
  getAllProducts,
  getEvents,
  getHomeSlider,
  getNewsAndArticles,
} from '../server';
import TeamSlider3 from '../element/teamSlider3';
import HomeSlider from '../element/homeslider1';
import ProjectSlider1 from '../element/projectSlider1';

const loaderVideo = require('../../video/finallogo.mp4');

function Index3() {
  const [loading, setLoading] = useState(true);
  const [homeSlider, setHomeSlider] = useState(null);
  const [aboutUs, setAboutUs] = useState(null);
  const [directors, setDirectors] = useState(null);
  const [products, setProducts] = useState(null);
  const [news, setNews] = useState(null);
  const [events, setEvents] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      Promise.all([
        getHomeSlider(),
        getAllAbout({ type: 'home_page' }),
        getAllDirectors({ type: 'board of directors' }),
        getAllProducts(),
        getNewsAndArticles(),
        getEvents(),
      ])
        .then(([homeRes, aboutRes, directorsRes, productsRes, newsRes, eventsRes]) => {
          setHomeSlider(homeRes);
          setAboutUs(aboutRes?.data[0]);
          setDirectors(directorsRes.data);
          setProducts(productsRes.data);
          setNews(newsRes.data);
          setEvents(eventsRes.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div
        className="loader-container"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          zIndex: 9999,
          overflow: "hidden",
        }}
      >
        <video
          src={loaderVideo} 
          autoPlay
          // loop
          muted
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
          }}
        />
      </div>
    );
  }
  
  

  return (
    <>
      <Header />
      <HomeSlider data={homeSlider} contentWrapperCls="sliderStyle4" hideBtn />
      {/* <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full content-inner bg-white">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 m-b30">
                  <div className="our-story">
                    <span>About Us</span>
                    <h2 className="title">{aboutUs?.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: `${aboutUs?.body.slice(0, 300)}...` }} />
                    <Link to="/about-us" className="site-button">Read More</Link>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 m-b30">
                  <img src={`https://hr.sweetitech.co.uk/abc/${aboutUs?.image?.url}`} className="radius-sm" alt="About Us" />
                </div>
              </div>
            </div>
          </div>
          <div className="section-full content-inner-2 bg-gray">
            <div className="container">
              <h2 className="title text-center">Our Products</h2>
              <ProjectSlider1 data={products} />
            </div>
          </div>
          <div className="section-full content-inner bg-white">
            <div className="container">
              <h2 className="title text-center">News & Articles</h2>
              <BlogSlider1 data={news} imgEffect="rotate" />
            </div>
          </div>
          <div className="section-full text-center bg-white content-inner-2">
            <div className="container">
              <h2 className="title">Board Of Directors</h2>
              <TeamSlider3 team={directors} />
            </div>
          </div>
          <div className="section-full content-inner-2 bg-gray">
            <div className="container">
              <h2 className="title text-center">Events & Publications</h2>
              <Testimonial1 data={events} />
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
}
export default Index3;
